import Footer from './Assets/Footer.js'
import Header from './Assets/Header.js'
import {Link} from 'react-router-dom';
import Button from './Assets/Button.js'

function SuccessPage() {
    return (
        <>
        <Header/>
        <section class="SP-Section">
                <h1>Success!</h1>
                <img src={require("../TutorImage.jpg")} alt="Tutor" class="SP-Image-2"/>
                <div>
                    <h1>Success!</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. </p>
                    <Button path="/" name="Back to HomePage" style="Button"/>
                </div>
                <img src={require("../TutorImage.jpg")} alt="Tutor" class="SP-Image-1"/>
        </section>
        <Footer/>
        </>
    )
}

export default SuccessPage